import { Injectable, inject } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HotkeysService {
  private manager = inject(EventManager);

  dispose = new Map<string, () => void>();
  #key$ = new Subject<string>();
  hotkeys = new Map<string, Observable<boolean>>();

  add(key: string, preventDefault = false): Observable<boolean> {
    const existing = this.hotkeys.get(key);
    if (existing) {
      return existing;
    }
    this.hotkeys.set(key, this.key$.pipe(map(k => k === key)));
    const keydownFn = this.manager.addEventListener(document as any, `keydown.${key}`, (event: Event) => {
      this.#key$.next(key);
      preventDefault && event.preventDefault();
    });
    this.dispose.set(key, keydownFn as any);
    return this.hotkeys.get(key)!;
  }

  remove(key: string) {
    this.dispose.get(key)?.();
    this.dispose.delete(key);
    this.hotkeys.delete(key);
  }

  get key$(): Observable<string> {
    return this.#key$.asObservable();
  }
}
